var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarrot = function SvgCarrot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 147,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M168.845 112.345c-22.606 28.886-79.194 36.343-112.495 16.658-33.301-19.685-74.43-43.057-9.388-64.74C94.291 41.013 95.106 2.05 149.48 34.192c33.301 19.686 41.971 49.267 19.365 78.152z",
    fill: props.accentFill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.518 72.075c-1.537 11.16 8.382 70.872 16.418 71.611 7.962.732 25.817-49.643 30.316-62.337l.121-.343c5.655-15.951-2.935-30.795-19.152-32.72-18.65-2.215-25.954 11.09-27.703 23.79z",
    stroke: "#363840",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.99 61.748c-3.46-5.279-9.396-7.583-9.658-7.682-.3-.115-.638-.09-.918.066s-.475.427-.527.737c-.046.271-1.046 6.434 1.835 12.035a11.888 11.888 0 00-5.315 1.5 1.05 1.05 0 00-.503.632c-.075.268-.039.554.102.795l1.061 1.818c1.895 3.253 5.208 5.347 8.927 5.747-1.858 3.46-1.988 7.688-.248 11.022l.008.018.009.014c1.306 2.501.413.838 25.716 28.467a4.98 4.98 0 006.085.949c2.028-1.129 2.954-3.435 2.27-5.602-11.02-34.78-10.572-33.37-10.588-33.414-.742-1.988-1.783-3.602-3.094-4.799a13.003 13.003 0 00-8.104-3.362c.259-.557.47-1.129.633-1.71.812-2.89.441-6.014-1.137-8.723l-1.061-1.818a1.085 1.085 0 00-1.461-.391 11.582 11.582 0 00-4.031 3.701zm-9.124-5.128c1.938.987 5.569 3.211 7.701 6.87 1.392 2.387 2.021 5.169 2.135 7.89l.87.942c-.293-.503-1.063-.671-1.577-.385-.514.286-.556 1.013-.263 1.515l-.892-1.035c-2.354-1.495-4.48-3.454-5.858-5.82-2.126-3.647-2.234-7.842-2.116-9.977zm-2.938 13.994l-.501-.86a9.718 9.718 0 014.606-.734c1.653 2.263 3.744 3.933 5.522 5.076-.432.398-.835.824-1.206 1.276-3.487.017-6.682-1.775-8.42-4.758zM57.69 75.58c1.057.964 1.91 2.298 2.534 3.962l.167.525-5.231 2.91a1.034 1.034 0 00-.401 1.427c.293.502.946.677 1.46.391l4.82-2.68 3.244 10.237-4.624 2.573a1.034 1.034 0 00-.4 1.427c.292.502.946.678 1.46.392l4.212-2.344 3.244 10.238-4.016 2.234a1.035 1.035 0 00-.4 1.428c.292.502.947.677 1.46.391l3.605-2.005 1.963 6.195c.387 1.228-.14 2.529-1.283 3.165a2.812 2.812 0 01-3.436-.534l-8.854-9.592 2.963-1.648c.514-.287.694-.926.4-1.428a1.085 1.085 0 00-1.46-.391l-3.372 1.876-7.344-7.957 5.415-3.014c.514-.286.693-.925.4-1.427a1.085 1.085 0 00-1.46-.391l-5.824 3.24-5.135-5.563a12.013 12.013 0 01-.624-.866l5.48-3.05c.514-.285.694-.925.401-1.427a1.085 1.085 0 00-1.46-.391l-5.382 2.994c-1.58-4.231.167-9.73 4.864-12.34 4.098-2.281 9.207-1.668 12.614 1.443zm-9.008-14.289a9.187 9.187 0 01-.107 9.503c-.589.081-1.17.202-1.74.362-.099-2.078-.502-4.688-1.65-7.23a9.368 9.368 0 012.996-3.495l.501.86z",
    fill: "#363840",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.616 75.102c1.743 0 3.155-1.391 3.155-3.107 0-1.716-1.412-3.107-3.155-3.107-1.742 0-3.155 1.391-3.155 3.107 0 1.716 1.413 3.106 3.155 3.106zM130.684 77.062c1.743 0 3.155-1.39 3.155-3.106s-1.412-3.107-3.155-3.107c-1.742 0-3.155 1.391-3.155 3.107 0 1.716 1.413 3.106 3.155 3.106z",
    fill: "#363840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.388 85.56l-19.971-1.964c-.352 3.414.542 9.415 9.03 10.25 7.489.737 10.589-4.87 10.941-8.285z",
    stroke: "#363840",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98546 .1699 -.17775 .98408 98.425 106.147)",
    stroke: "#363840",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5-2.5h11.307"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98546 .1699 -.17775 .98408 101.436 127.718)",
    stroke: "#363840",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5-2.5h9.302"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98546 .1699 -.17775 .98408 113.479 118.403)",
    stroke: "#363840",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5-2.5h11.307"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.341 3.196c-15.736 17.253-12.839 36.939-9.424 44.625l6.048 1.004c14.062-21.318 8.11-39.302 3.376-45.629z",
    stroke: "#363840",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.805 28.166c1.833-.988 7.915-5.294 12.804-4.87.385 6.35-2.002 22.056-14.393 27.901M119.585 26.037c-1.449-1.59-7.543-6.09-12.293-7.44-2.205 5.875-3.393 20.762 9.487 29.394",
    stroke: "#363840",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175.101 75.318l-5.885-2.508-2.546 5.794 5.884 2.508 2.547-5.794z",
    fill: "#363840"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.42 35.978l-.607-4.348-4.47.62.606 4.348 4.47-.62z",
    fill: props.accentFill
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.094 65.55c2.083 0 3.772-1.662 3.772-3.713 0-2.052-1.689-3.714-3.772-3.714-2.083 0-3.772 1.662-3.772 3.714 0 2.05 1.689 3.714 3.772 3.714z",
    fill: "#363840"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.688 58.103c1.108 0 2.007-.878 2.007-1.961 0-1.083-.899-1.961-2.007-1.961-1.109 0-2.007.878-2.007 1.96 0 1.084.898 1.962 2.007 1.962z",
    fill: props.accentFill
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.623 55.082l14.545-9.193M91.553 52.167L69.864 46M96.928 45.826l-3.87-5.373M154.626 64.978l11.268.128",
    stroke: "#363840",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgCarrot;